import React, { useEffect, useState, useMemo, FC } from "react";
import { Link } from "react-router-dom";

import { Col, Row, Button, Spinner } from "reactstrap";
import DataTable from "../../shared/base-components/DataTable";
import { useSupplierListMutation } from "./Supplier.actions";
import StaffModal from "./SupplierModal";
import { MODAL_TYPES, Permissions } from "../../shared/models/Types";
import StaffDeleteModal from "./SupplierDeleteModal";
import { Supplier } from "./Supplier.constants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../shared/actions/Authentication.actions";
import SupplierDetailModal from "./SupplierDetailModal";
import useCookie from "../../shared/hooks/useCookie";

export interface SupplierListProps {
  isSupplierDetail: boolean;
  setIsSupplierDetail: React.Dispatch<React.SetStateAction<boolean>>;
}

const SupplierList: FC<SupplierListProps> = ({
  setIsSupplierDetail,
  isSupplierDetail,
}) => {
  document.title =
    "Tedarikçi | Bu ekranda tedarikçi ekleme güncelleme yapabilirsiniz.";
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );
  const [_, setCookieSupplierId] = useCookie("supplierId");

  const permissionList = useRecoilValue(permissionsSelector);

  const { data, mutate, isLoading } = useSupplierListMutation();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const [modalOptions, setModalOptions] = useState<{
    data?: Supplier;
    modalType?: string;
  }>({
    data: undefined,
    modalType: undefined,
  });

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const modalOptionsHandler = (data?: Supplier, modalType?: string) => {
    setModalOptions({ data: data, modalType: modalType });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Ad",
        filterable: false,
        disableFilters: true,
        accessor: "name",
        Cell: (user: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              <Link
                onClick={() => {
                  // setCookieSupplierId(user.row.original.id, 90);
                  // setIsSupplierDetail(true);
                }}
                to={"#"}
                className="text-dark"
              >
                {user.row.original.name}
              </Link>
            </h5>
            <p className="text mb-0">{}</p>
          </>
        ),
      },
      {
        Header: "Açıklama",
        filterable: false,
        disableFilters: true,
        accessor: "description",
        Cell: (user: any) => (
          <>
            <p className="text mb-0">{user.row.original.description}</p>
          </>
        ),
      },
      {
        Header: "Telefon",
        accessor: "phone_number",
        filterable: false,
        disableFilters: true,
        Cell: (user: any) => (
          <>
            <p className="text mb-0">{user.row.original.phone_number}</p>
          </>
        ),
      },

      // {
      //   Header: "Kalan Ödeme",
      //   accessor: "remaining",
      //   filterable: false,
      //   disableFilters: true,
      //   Cell: (user: any) => (
      //     <>
      //       <p className="text mb-0">{user.row.original.remaining} ₺</p>
      //     </>
      //   ),
      // },
      {
        Header: "İşlemler",
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              <Link className="text-warning" to="#">
                <i
                  className="mdi mdi-pencil font-size-18"
                  id="edittooltip"
                  onClick={() => {
                    const userData = cellProps.row.original;

                    toggle();
                    modalOptionsHandler(userData, MODAL_TYPES.UPDATE);
                  }}
                ></i>
              </Link>
              <Link className="text-danger" to="#">
                <i
                  className="mdi mdi-delete font-size-18"
                  id="deletetooltip"
                  onClick={() => {
                    const userData = cellProps.row.original;

                    toggle();
                    modalOptionsHandler(userData, MODAL_TYPES.DELETE);
                  }}
                ></i>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  const mobileColumns = useMemo(
    () => [
      {
        Header: "Ad Soyad/Telefon",
        filterable: false,
        disableFilters: true,
        accessor: "fullname",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original.name}

              <p className="font-size-13 text-muted mt-2">
                {response.row.original.phone_number}
              </p>
            </h5>
          </>
        ),
      },
      {
        Header: "İşlemler",
        accessor: "phone_number",
        disableFilters: true,
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              {updatePermission && (
                <Link className="text-warning" to="#">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    id="edittooltip"
                    onClick={() => {
                      const userData = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(userData, MODAL_TYPES.UPDATE);
                    }}
                  ></i>
                </Link>
              )}

              <Link className="text-danger" to="#">
                <i
                  className="mdi mdi-delete font-size-18"
                  id="deletetooltip"
                  onClick={() => {
                    const userData = cellProps.row.original;

                    toggle();
                    modalOptionsHandler(userData, MODAL_TYPES.DELETE);
                  }}
                ></i>
              </Link>

              <Link className="text-success" to="#">
                <i
                  className="mdi mdi-eye font-size-18"
                  id="deletetooltip"
                  onClick={() => {
                    const userData = cellProps.row.original;

                    toggle();
                    modalOptionsHandler(userData, MODAL_TYPES.DETAIL);
                  }}
                ></i>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    mutate({});
  }, []);

  const addPermission = permissionList[Permissions.AddSupplier];
  const updatePermission = permissionList[Permissions.ChangeSupplier];
  const viewPermission = permissionList[Permissions.ViewSupplier];
  const deletePermission = permissionList[Permissions.DeleteSupplier];

  return (
    <React.Fragment>
      <Row className="align-items-center">
        <Col md={6}>
          <div className="mb-3">
            <h5 className="card-title">
              Tedarikçi Listesi
              <span className="text-muted fw-normal ms-2">
                {isLoading ? (
                  <Spinner className="ms-1" color="primary" />
                ) : (
                  `(${data?.length})`
                )}
              </span>
            </h5>
          </div>
        </Col>

        <Col md={6}>
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
            <div>
              <ul className="nav nav-pills"></ul>
            </div>
            <div>
              {addPermission && (
                <Button
                  onClick={() => {
                    toggle();
                    modalOptionsHandler(undefined, MODAL_TYPES.CREATE);
                  }}
                  className="btn btn-light"
                >
                  <i className="bx bx-user-plus me-1"></i> Tedatikçi Ekle
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          {data?.length && viewPermission ? (
            <DataTable
              columns={isMobile ? mobileColumns : columns}
              data={data}
              isGlobalFilter={true}
              isAddUserList={true}
              customPageSize={10}
              className="table align-middle datatable dt-responsive table-check nowrap"
            />
          ) : (
            !isLoading && <>Tedarikçi bulunamadı</>
          )}
        </Col>
      </Row>

      {isModalOpen &&
        updatePermission &&
        (modalOptions.modalType === MODAL_TYPES.CREATE ||
          modalOptions.modalType === MODAL_TYPES.UPDATE) && (
          <StaffModal
            userData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
            mutate={mutate}
          />
        )}

      {isModalOpen &&
        deletePermission &&
        modalOptions.modalType === MODAL_TYPES.DELETE && (
          <StaffDeleteModal
            mutate={mutate}
            userData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
          />
        )}

      {isModalOpen && modalOptions.modalType === MODAL_TYPES.DETAIL && (
        <SupplierDetailModal
          userData={modalOptions.data}
          modalType={modalOptions.modalType}
          isModalOpen={isModalOpen}
          toggle={toggle}
        />
      )}
    </React.Fragment>
  );
};

export default SupplierList;
